// Regiao de Estudo
import api from '@/api';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import { debug } from 'util';



var SHOPPING_STAGES = ['products-chooser','products-infos','identification','checkout']

export default function (data) {

  var state = {
    currentStage: SHOPPING_STAGES[0],
    lastCompleteStage: SHOPPING_STAGES[0],
    completeStages:[],
  }

  return {
    namespaced: true,
    
    state: state,

    mutations: {
      
      setState: function (state, obj) {
          for(var k in obj){
            state[k] = obj[k]
          }
      },

      currentStage:function(state,stage=''){
          state.currentStage = stage;
          let lastCompleteStageIndex = _.findIndex(SHOPPING_STAGES,v=>v==stage.lastCompleteStage)
          let currentStageIndex = _.findIndex(SHOPPING_STAGES,v=>v==stage.currentStage)
          if(currentStageIndex >= lastCompleteStageIndex){
            state.lastCompleteStage = stage
          }
      }

    },


    actions: {

        addProduct:function(ctx, {productId,total}){
          for (let i = 0; i < total; i++) {
              ctx.dispatch('OrderStore/addProduct',productId,{root:true})
          }
        },
        removeProduct:function(ctx, {productId,total} ){
          for (let i = 0; i < total; i++) {
            ctx.dispatch('OrderStore/removeLastProductOfId',productId,{root:true})
          }
        },
    },


    getters: {
      
      currentStage: stage => stage.currentStage,

      lastCompleteStage: stage => stage.lastCompleteStage,
      
      currentStageIndex: stage=>{
        return _.findIndex(SHOPPING_STAGES,v=>v==stage.currentStage)
      },

      lastCompleteStageIndex: stage => {
         return _.findIndex(SHOPPING_STAGES,v=>v==stage.lastCompleteStage)
      },
      
      totalForProductId: (stage, getters, rootState, rootGetters) => productID =>{
          let purshasesProducts = rootGetters['OrderStore/purshaseProductsForProductId'](productID)
          return purshasesProducts.length || 0;
      },

      havePurchaseProducts:(stage, getters, rootState, rootGetters) =>{
        
      }

      
    }

  }
}
